import { pricingAdvisor } from '../pricing'
import { quoteAnalyzer } from '../analysis'
import { supplierAdvisor } from '../analysis'
import type {
  AIRecommendation,
  QuoteAnalysisInput,
  QuoteAnalysisResult,
  SupplierAdvice,
} from '../types'
import type { SupplierCandidate } from '../analysis/SupplierAdvisor'

/**
 * RecommendationEngine — supplier, price, profit, margin and delivery suggestions.
 */
export class RecommendationEngine {
  fromQuote(input: QuoteAnalysisInput): {
    analysis: QuoteAnalysisResult
    recommendations: AIRecommendation[]
  } {
    const analysis = quoteAnalyzer.analyze(input)
    const recommendations = [...analysis.recommendations]

    if (analysis.averageMargin < (input.targetMargin ?? 20)) {
      recommendations.push({
        id: crypto.randomUUID(),
        kind: 'profit',
        title: 'Ajustar lucro do pedido',
        suggestion: 'Revisar itens com maior volume e menor margem',
        reason: `Margem média ${analysis.averageMargin}% comprime o lucro total do orçamento`,
        confidence: 0.77,
        requiresConfirmation: true,
      })
    }

    const slow = input.items.filter((i) => (i.marketMaxPrice ?? 0) > 0)
    if (slow.length) {
      recommendations.push({
        id: crypto.randomUUID(),
        kind: 'delivery',
        title: 'Validar prazo dos itens críticos',
        suggestion: 'Confirmar lead time dos fornecedores antes do envio ao cliente',
        reason: 'Itens com variação de mercado costumam ter prazos distintos entre distribuidores',
        confidence: 0.7,
        requiresConfirmation: true,
      })
    }

    return { analysis, recommendations }
  }

  forSupplier(product: string, candidates: SupplierCandidate[]): SupplierAdvice {
    return supplierAdvisor.advise(product, candidates)
  }

  forPrice(input: {
    description: string
    purchasePrice: number
    currentSalePrice?: number
    targetMargin?: number
    category?: string
  }) {
    return pricingAdvisor.advise(input)
  }
}

export const recommendationEngine = new RecommendationEngine()
